import { contactData } from '@/mocks/comics';

export default function ContactSection() {
  return (
    <section id="contact" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">
            {contactData.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
            {contactData.intro}
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {contactData.items.map((item) => (
              <div
                key={item.label}
                className="bg-background-100 rounded-xl p-5 flex flex-col items-center gap-3"
              >
                <div className="w-12 h-12 rounded-full bg-primary-50 flex items-center justify-center">
                  <i className={`${item.icon} text-primary-600 text-xl`}></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-500 mb-1">{item.label}</p>
                  <p className="text-sm font-medium text-foreground-800">{item.value}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}